import React from 'react'
import { Panel, TextFieldIcon, SelectFieldIcon } from '../../../_components'

export default function Leadership( { values, handleChange, handleBlur, data } ) {
  return (
    <Panel label="Leadership">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 md:gap-2 lg:gap-2">
            <SelectFieldIcon 
                name="leader"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.leader}
                label="Leadership"
                required={true}
                question="Are you a Leader?"
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                options={data.yesno.map( item => ( { id: item.id, label: item.label, value: item.value } ) )} />

            { values.leader === "Yes" &&
             ( <SelectFieldIcon 
                name="institution_type"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.institution_type}
                label="Institution"
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                required={values.leader === "Yes" ? true : false}
                question="Institution"
                options={data.institution_types.map( item => ( { id: item.id, label: item.label, value: item.value } ) )} 
            /> ) }

            { values.leader === "Yes" && (
             <SelectFieldIcon 
                name="position"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.position}
                label="Position"
                disabled={localStorage.getItem( "tag" ) === "view" ? true : false}
                required={values.leader === "Yes" ? true : false}
                question="Position"
                options={data.position.map( item => ( { id: item.id, label: item.label, value: item.value } ) )} 
            /> ) }
        </div>
    </Panel>
  )
}
